module.exports = __webpack_public_path__ + "static/img/four-bg-DF1WlLbX.a329e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/four-bg-DF1WlLbX.png
// module id = BrIu
// module chunks = 16